/**
 * Created by satans17 on 2016/12/21.
 */

import Robot from './robot';
import Agent from './agent';
import firstmessage from '../../module/firstmessage/index.js';
import feedback from '../../module/feedback';
import { AGENT, ROBOT } from '../../../const/objects.const';
import { getTranslation as translate } from '../../../utils';

export default class Channel {
  constructor(app) {
    this.app = app;
    this.init();
  }

  init() {
    this.curRole = 'robot';
    this.robot = this.initRobot(this.app);
  }

  initRobot() {
    return new Robot(this.app);
  }

  /**
   * 切换到机器人
   * @param config
   */
  switchToRobot(config, showWelcomeMessage, hideAgentShortcut) {
    this.robot.online(config);
    this.curRole = ROBOT;
    const headerData = {
      title: this.app.param.botName,
    };
    this.app.view.header.switchRole(ROBOT, headerData);
    this.app.view.footer.switchRole(ROBOT);
    if (showWelcomeMessage && !this.shownWelcome) {
      this.app.welcomeMsg();
      firstmessage(this.app);
      this.shownWelcome = true;
    }
    this.app.view.body.scrollToBottom();

    if (hideAgentShortcut) {
      this.app.shortcuts.hideAgent();
    }
    this.app.shortcuts.switchToRobot();
  }

  switchToAgent(config, newSession, showTransfering) {
    if (!this.agent) {
      this.app.on(this.app.events.SHOW_FEEDBACK, () => {
        feedback(this.app);
      });
      this.agent = new Agent(this.app);
    }
    if (config) {
      this.agent.online(config, newSession, showTransfering);
    }
    this.useAgentUI();
  }

  useAgentUI(requestLogin) {
    this.curRole = AGENT;
    const { header } = this.app.xspace;
    this.app.view.header.switchRole(AGENT, header);
    this.app.view.footer.switchRole(AGENT);

    if (requestLogin) {
      this.app.view.footer.blockChatAgent();
      this.app.view.footer.hideShortcuts();
      this.app.appendMessage({
        type: 'agentChatLogin',
        body: {
          loginMessage: translate('csc.login_agent_request'),
        },
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/context/channel/index.js